export const getResultsById = (state, id) => state.results[id];
